module.exports = __webpack_public_path__ + "img/prawn.e2cc0fb8.png";